import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3000/api";

axios.defaults.withCredentials = true;

export const login = async (username, password) => {
  const res = await axios.post(`${BASE_URL}/auth/login`, { username, password });
  return res.data;
};

export const logout = async () => {
  await axios.post(`${BASE_URL}/auth/logout`);
};

export const getMe = async () => {
  const res = await axios.get(`${BASE_URL}/auth/me`);
  return res.data;
};

export const fetchCostData = async (startDate, endDate, tag = null, accountId = null) => {
  const res = await axios.get(`${BASE_URL}/cost`, {
    params: {
      startDate,
      endDate,
      ...(tag && { tag }),
      ...(accountId && { accountId })
    }
  });

  return res.data;
};

export const fetchCostByAccount = async (startDate, endDate) => {
  const res = await axios.get(`${BASE_URL}/cost/by-account`, {
    params: { startDate, endDate }
  });

  return res.data;
};

export const fetchCostTrend = async () => {
  const res = await axios.get(`${BASE_URL}/cost/trend`);
  return res.data;
};

export const fetchAccountServiceTrend = async (accountId) => {
  const res = await axios.get(`${BASE_URL}/cost/account-trend`, {
    params: { accountId }
  });
  return res.data;
};
